
import {
  ApiResponse,
  ConsultorioId
} from '../types';

// Configuração da API usando variáveis de ambiente
export const API_CONFIG = {
  baseUrl: import.meta.env.VITE_GOOGLE_REVIEWS_API_URL || 
           (import.meta.env.PROD 
             ? 'https://place-api-backend-production.up.railway.app/api'
             : 'http://localhost:3001/api'),
  // Remove API keys from frontend - these should be handled by backend
  apiKey: '', // Removed for security - backend should handle authentication
  googleApiKey: '', // Removed for security - backend should handle authentication
  endpoints: {
    allReviews: '/reviews',
    placeReviews: '/reviews/place',
    stats: '/reviews/stats',
    recent: '/reviews/recent'
  }
};

// Mapeamento correto de IDs dos consultórios para Place IDs do Google
export const PLACE_IDS: Record<ConsultorioId, string> = {
  paulista: 'ChIJacyRM7VxniwRmfOb_GNaDS8',
  mogi: 'ChIJZb7dOIrZzZQRdPAfnaevDe0',
  suzano: 'ChIJpcJea7Z7zpQRgxHGFUCksvM'
};

// Nomes corretos dos consultórios
export const CONSULTORIO_NAMES: Record<ConsultorioId, string> = {
  paulista: 'Dra. Brenda Ramos - Nutricionista Clínica - Av. Paulista/SP',
  mogi: 'Dra. Brenda Ramos - Nutricionista Clínica - Centro de Mogi das Cruzes/SP',
  suzano: 'Dra. Brenda Ramos - Nutricionista Clínica - Centro de Suzano/SP'
};

// Endereços dos consultórios
export const CONSULTORIO_ADDRESSES: Record<ConsultorioId, string> = {
  paulista: 'Av. Paulista, 807 - conj 1001 - Bela Vista, São Paulo - SP, 01311-100, Brasil',
  mogi: 'R. Juvenal Granado Nale, 55 - Centro, Mogi das Cruzes - SP, 08710-550, Brasil',
  suzano: 'R. Paraná, 11 - Edifício Arupati - Centro, Suzano - SP, 08675-190, Brasil'
};

// Função para fazer requisições à API
export async function apiRequest<T>(endpoint: string): Promise<T> {
  const url = `${API_CONFIG.baseUrl}${endpoint}`;
  
  console.log('🔄 Google Reviews API Request:', url);
  console.log('🛠️ Ambiente:', import.meta.env.PROD ? 'Produção' : 'Desenvolvimento');
  
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
      // Removed API keys from headers - backend should handle authentication
    },
    signal: AbortSignal.timeout(15000) // 15 segundos timeout
  });

  if (!response.ok) {
    const errorText = await response.text();
    console.error('❌ Erro na API Google Reviews:', response.status, response.statusText, errorText);
    throw new Error(`Erro na API Google Reviews: ${response.status} ${response.statusText}`);
  }

  const data: ApiResponse<T> = await response.json();
  
  if (!data.success) {
    console.error('❌ Erro na resposta da API:', data.error);
    throw new Error(data.error || 'Erro desconhecido na API Google Reviews');
  }

  console.log('✅ Dados recebidos da API:', data);
  return data.data as T;
}
